<template>
    <div id="roleManger">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
                <el-row>
                    <div>
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span>角色管理</span>
                            </div>
                            <div class="HeadSearch search_warn_detail">
                                <div class="searchBtn special" @mousemove="mousearch">
                                    <i></i>
                                    <el-input placeholder="搜索角色名称" v-model="roleList.searname" clearable @clear="clearableBack" ref="inputRef" @blur="searchBlur()"></el-input>
                                </div>
                                <div class="screenBtn">
                                    <a @click="screenBtnShow = true">筛选</a>
                                    <div class="screenTip" v-show="screenBtnShow">
                                        <div class="screenHead">
                                            <div class="headTxt">筛选</div>
                                            <div class="headIcon" @click.stop="screenBtnShow = false"></div>
                                        </div>
                                        <div class="screenMain">
                                            <el-form :model="ruleFormOption" ref="ruleFormOption" class="demo-ruleForm">
                                                <el-form-item prop="roleStatusVal"> 
                                                    <div class="formHead">{{roleStatus.title}}</div>
                                                    <div class="formMain">
                                                        <el-checkbox-group v-model="ruleFormOption.roleStatusVal">
                                                            <el-checkbox-button v-for="(item,index) in roleStatus.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                                        </el-checkbox-group>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item class="screenMainBtn">
                                                    <el-button @click="resetruleFormOption('ruleFormOption')">重置</el-button>
                                                    <el-button type="primary" @click="submitruleFormOption('ruleFormOption')">确定</el-button>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                </div>
                                <el-button type="primary" @click="editorialRole()" v-if="isAuth('roles:addroles')">新增角色</el-button>
                            </div>
                        </div>
                    </div>
                  <div class="fixedScorll" :style="{height:basicHeight+'px'}">
                    <div class="tabs">
                      <div v-show="select4" class="table_data">
                        <el-table :data="tableData" style="width: 100%" border @row-click="lookDetail">
                          <el-table-column prop="orderNum" label="序号" width="70">

                          </el-table-column>
                          <el-table-column prop="name" label="角色名称" min-width="154"></el-table-column>
                          <el-table-column prop="enabled" label="启用状态" min-width="103"></el-table-column>
                          <el-table-column prop="remark" label="备注" min-width="438"></el-table-column>
                          <el-table-column prop="createDate" label="创建时间" min-width="193"></el-table-column>
                          <el-table-column prop="modifyDate" label="最近修改时间" min-width="193"></el-table-column>
                          <el-table-column label="操作" min-width="205" fixed="right">
                            <template slot-scope="scope">
                              <div v-if="scope.row.roleType==1" class="no_btn">
                                <div class="buleColor" style="width: 36px">--</div>
                                <div class="buleColor" style="width: 36px">--</div>
                                <div class="buleColor">--</div>
                              </div>
                              <div v-else-if="scope.row.roleType==2">
                                <div class="buleColor" @click.stop="modifyRoute(scope.row)" style="cursor: pointer" v-if="isAuth('roles:editRoles')">编辑</div>
                                <div  class="buleColor" style="width: 36px">--</div>
                                <div class="buleColor"  @click.stop="setUser(scope.row)" v-if="isAuth('roles:editUserRoles')" style="cursor: pointer">设置人员</div>
                              </div>
                              <div v-else>
                                <div class="buleColor"  @click.stop="modifyRoute(scope.row)" style="cursor: pointer" v-if="isAuth('roles:editRoles')">编辑</div>
                                <div class="buleColor"  @click.stop="getUserRoles(scope.row)" v-if="isAuth('roles:deleteRoles')" style="cursor: pointer">删除</div>
                                <div class="buleColor" @click.stop="setUser(scope.row)" v-if="isAuth('roles:editUserRoles')" style="cursor: pointer">设置人员</div>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                        <div style="text-align: right;margin-top: 15px" v-if="statusNum > 20">
                          <el-pagination @size-change="handleSizeChange1"  @current-change="handlepageChange1" :current-page.sync="roleList.currPage" :page-size="20" layout="prev, pager, next" :total='statusNum' background></el-pagination>
                        </div>
                      </div>
                      <div class="No" v-show="!select4">
                        <img src="../../../static/img/Nodata.png">
                        <span>暂无数据</span>
                      </div>
                      <!-- 设置人员信息弹出框 -->
                      <el-dialog title="人员设置" :visible.sync="select3" width="652px" class="deviceCss"
                                 :close-on-press-escape=false
                                 :close-on-click-modal=false
                      >
                        <div class="deviceBinding">
                          <div class="searchBtn user_input" @mousemove="mousearch1">
                            <i></i>
                            <el-input placeholder="搜索用户姓名、工号、账号或联系方式" v-model="userList.searname" clearable @blur="selectUser()" @clear="clearableBack1" ref="inputRef1"></el-input>
                          </div>
                        </div>
                        <el-table :data="userData" style="max-width:611px;" height="312px"
                                  @row-click="handleCurrentChange" border class="user_table"
                                  :row-class-name="tableRowClassName"
                        >
                          <el-table-column property="userName" label="姓名" width="100" show-overflow-tooltip></el-table-column>
                          <el-table-column property="userNumber" label="工号" width="136" show-overflow-tooltip></el-table-column>
                          <el-table-column property="loginName" label="账号" width="168" show-overflow-tooltip></el-table-column>
                          <el-table-column property="userPhone" label="联系方式" width="128" show-overflow-tooltip></el-table-column>
                          <el-table-column property="enabled" label="状态" width="78" show-overflow-tooltip></el-table-column>
                        </el-table>
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="select3 = false">取 消</el-button>
                          <el-button type="primary" @click="getEditUserRoles()" v-if="isAuth('roles:editUserRoles')">确 定</el-button>
                        </div>
                      </el-dialog>
                    </div>
                  </div>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import topNav from '../../components/TopNav.vue';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'roleManger',
        data() {
            return {
                msg: '角色管理',
                select3: false,
                select4: true,
                tabWidth1: '',tabWidth2: '',tabWidth3: '',tabWidth4: '',tabWidth5: '',
                screenBtnShow: false,
                statusNum: 0,   //分页总条数
                roleList: {     //获取角色列表参数
                    currPage: 1,    //当前页
                    pageSize: 20,   //每页数量
                    searname: '',   //搜索名
                    enables: '',
                },
                userList: {     //获取人员设置列表参数
                    currPage: 1,    //当前页
                    pageSize: 500,   //每页数量
                    searname: '',   //搜索名
                    enabled: '',
                },
                //筛选多选值
                ruleFormOption: { 
                    roleStatusVal:[]
                },
                //筛选-角色状态
                roleStatus: {
                    title:'角色状态:',
                    option:[{
                        name:'启用',
                        value:'0'
                    },{
                        name:'禁用',
                        value:'1'
                    }]
                },
                tableData: [],
                userData: [],
                selectIndex:[],
                selectId:[],   //选择的id
                roleId:'',
                basicHeight:0,
                target:0,
                target1:0,
                windowResize:null,
            }
        },
        mounted() {
            let that = this;
            that.windowResize=function () {
                that.basicHeight=$('body').height()-$('.mainHead').outerHeight(true)-71;
                that.isRoleScroll();
            };
            that.windowResize();
            window.addEventListener('resize',that.windowResize);

            if(this.isAuth('common:interface')){
              this.getRoleList();
            }
            if(this.isAuth('common:interface')){
              this.getUsersList();
            }
            this.listenKeyDown();
        },
        methods: {
          //表格设置颜色
          tableRowClassName({row, rowIndex}) {
            if (this.selectIndex.indexOf(rowIndex)!==-1) {
              return 'select-row';
            }
            return '';
          },
          isRoleScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                document.getElementsByClassName('fixedScorll')[0].style.marginRight='3px';
              }else {
                document.getElementsByClassName('fixedScorll')[0].style.marginRight='20px';
              }
            });
          },
            //搜索
            searchBlur(){
              if(this.target==1){
                this.roleList.searname= '';
                this.$refs.inputRef.$el.children[0].focus();
                this.target = 0
              }else {
                this.roleList.currPage=1;
                this.getRoleList();
              }
            },
            //监听enter键
            listenKeyDown(){
              let _this=this;
              document.onkeydown=function(event){
                var e = event || window.event || arguments.callee.caller.arguments[0];
                if(e && e.keyCode==13){//上,左
                  _this.roleList.currPage=1;
                  if(_this.select3){
                    _this.getUsersList();
                  }else {
                    _this.getRoleList();
                  }
                }
              };
            },
            mousearch(event){
              if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
                this.target = 1;
              }else{
                this.target = 0
              }
            },
          mousearch1(event){
            if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
              this.target1 = 1;
            }else{
              this.target1 = 0
            }
          },
            // 获取角色列表
            getRoleList() {
                let parms = {
                    currPage: this.roleList.currPage,
                    pageSize: this.roleList.pageSize,
                    searname: this.roleList.searname,
                    enables: this.roleList.enables,
                };
                ajaxFuncJson('/roles/list',parms).then(res=>{
                    if(res.data.status == 200) {
                        this.tableData = res.data.data.rows;
                        this.statusNum = res.data.data.total;
                        if(this.statusNum > 0) {
                            this.select4 = true;
                            for(var i in this.tableData) {
                                this.tableData[i].orderNum = 20*(this.roleList.currPage-1)+(parseInt(i) + 1);
                                if(this.tableData[i].enabled == true) {
                                    this.tableData[i].enabled = '禁用'
                                } else {
                                    this.tableData[i].enabled = '启用'
                                }
                            }
                        } else {
                            this.select4 = false;
                        }
                        this.isRoleScroll();
                    }
                });
            },
            //搜索角色名称 - 清除回调
            clearableBack() {
               this.$refs.inputRef.$el.children[0].focus();
            },
            // 筛选确定按钮
            submitruleFormOption(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.roleList.enables = this.ruleFormOption.roleStatusVal.join(',');
                        this.getRoleList();
                        this.screenBtnShow = false;
                    } else {
                        return false;
                    }
                });
            },
            // 筛选重置按钮
            resetruleFormOption(formName) {
                this.$refs[formName].resetFields();
                this.roleList.enables='';
                this.getRoleList();
            },
            //分页按钮
            handlepageChange1(val){
                this.tableData = [];
                this.roleList.currPage = val;
                this.getRoleList();
            },
            //分页按钮
            handleSizeChange1(val){
                this.tableData = [];
                this.roleList.currPage = val;
                this.getRoleList();
            },
          //查看详情
            lookDetail(row, column, event){
              this.$router.push({path:'/editorialRole',query:{id:row.id,search:'1-1',type:'look',roleType:'2'}});
            },
            // 新增角色按钮
            editorialRole() {
                this.$router.push({path:'/editorialRole',query:{type:'add'}})
            },

            //..........................................修改................................
            
            modifyRoute(row) {
                this.$router.push({path:'/editorialRole',query:{id:row.id,roleType:row.roleType}})
            },
            setUser(item){
              this.roleId=item.id;
              if(this.isAuth('common:interface')){
                this.getRolesInfo();
              }
              this.select3=true;
            },
          //..........................................删除................................
            
            // 点击删除 - 判断角色信息是否存在用户
            getUserRoles(row) {
                let parms = {
                    roleId: row.id,  //角色id
                };
                ajaxFuncJson('/roles/getUserRoles',parms).then(res=>{
                    if(res.data.status == 200) {
                      this.$confirm('确定删除'+row.name+'角色？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                      }).then(() => {
                        this.getDeleteRoles(row);
                      }).catch(() => {

                      });
                    } else if(res.data.status == 405){
                      this.$confirm(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                      }).then(() => {
                        this.getDeleteRoles(row);
                      }).catch(() => {

                      });
                    }
                });
            },
            // 确定按钮 - 删除角色
            getDeleteRoles(item) {
                let parms = {
                    roleId: item.id, //角色id
                };
                ajaxFuncJson('/roles/deleteRoles',parms).then(res=>{
                    if(res.data.status == 200){
                      this.$alert('删除成功', '提示', {
                        confirmButtonText: '我知道了',
                        callback: action => {
                          if(this.tableData.length===1){
                            if(this.roleList.currPage>1){
                              this.roleList.currPage=this.roleList.currPage-1;
                            }
                          }
                          this.getRoleList();
                        }
                      });
                    }else {
                        this.$message({
                          message:res.data.msg,
                          type:'error',
                        })
                    }
                });
            },
            //筛选
            selectUser(){
              if(this.target1==1){
                this.userList.searname= '';
                this.$refs.inputRef1.$el.children[0].focus();
                this.target1 = 0
              }else {
                if(this.isAuth('common:interface')){
                  this.getUsersList();
                }
              }
            },
            //........................................设置人员...............................
            
            // 获取人员设置列表
            getUsersList() {
                let parms = {
                    currPage: this.userList.currPage,
                    pageSize: this.userList.pageSize,
                    searname: this.userList.searname,
                    enabled: this.userList.enabled,
                }
                ajaxFuncJson('/users/list',parms).then(res=>{
                    if(res.data.status == 200){
                        this.selectIndex=[];
                        this.userData = res.data.data.rows;
                        this.userData.forEach((a,b)=>{
                          if(this.selectId.indexOf(a.id)!==-1){
                            this.selectIndex.push(b);
                          }
                        });
                        for(var i in this.userData) {
                            if(this.userData[i].enabled == true) {
                                this.userData[i].enabled = '禁用'
                            } else {
                                this.userData[i].enabled = '启用'
                            }
                          this.$set(this.userData[i],'index',i);
                        }
                    }
                });
            },
            // 用户角色绑定 - 设置人员弹窗确定按钮
            getEditUserRoles() {
                let parms = {
                    roleId:this.roleId,  //角色id
                    userIds:this.selectId,
                };
                ajaxFuncJson('/roles/editUserRoles',parms).then(res=>{
                    if(res.data.status == 200){
                      this.select3=false;
                      this.$alert('设置成功', '提示', {
                        confirmButtonText: '我知道了',
                        callback: action => {
                          this.getRoleList();
                        }
                      });
                    }else {
                      this.$message({
                        message:res.data.msg,
                        type:'error'
                      })
                    }
                });
            },
            //人员设置搜索 - 清除回调
            clearableBack1() {
               this.$refs.inputRef1.$el.children[0].focus();
            },
            //获取角色的信息
            getRolesInfo(){
              let params={
                roleId:this.roleId,
              };
              ajaxFuncJson('/roles/findRoles',params).then(res=>{
                if(res.data.status==200){
                  this.selectIndex=[];
                  this.selectId=res.data.data.users;
                  this.userData.forEach((a,b)=>{
                    if(this.selectId.indexOf(a.id)!==-1){
                      this.selectIndex.push(b);
                    }
                  });
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error',
                  })
                }
              })
            },

            // 选中的人员
            handleCurrentChange(row){
              if(this.selectIndex.indexOf(Number(row.index))!==-1){
                this.selectIndex.splice(this.selectIndex.indexOf(Number(row.index)),1);
                this.selectId.splice(this.selectIndex.indexOf(Number(row.index)),1);
              }else {
                this.selectIndex.push(Number(row.index));
                this.selectId.push(row.id);
              }
            },
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        },
        components: {
            topNav,
        }
    }
</script>
<style lang="scss">
    @import "@/assets/css/mixin.scss";
    @import "@/assets/css/style.scss";
    #roleManger {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
                width: 100% !important;
                margin: 0 !important;
                background: #f2f2f2;
                .el-row {
                  .mainHead{
                    margin: 10px 20px 0 20px;
                  }
                }
            }
        }
      .fixedScorll{
        background: #fff;
        margin-left: 20px;
        margin-right: 20px;
      }
        .HeadSearch {
            @include flexible;
            @include alignItems(center);
            @include justify(space-between);
            .screenBtn{
              position: relative;
              float: left;
              >i {
                position: absolute;
                top: 8px;
                left: 10px;
                @include wh(16px,16px);
                @include bgImg('../../assets/img/search2.png');
                cursor: pointer;
                z-index: 1;
              }
              .el-input__inner {
                padding-left: 36px !important;
              }
                a {
                    float: right;
                    width: 48px;
                    margin: 0 20px;
                    padding-right: 20px;
                    box-shadow: 1px 0 0 #e0e0e0;
                    font-weight: normal;
                }
                .screenTip {
                    position: absolute;
                    right: 38px;
                    top: 28px;
                    z-index: 1000;
                    width: 340px;
                    min-height: 345px;
                    border: 1px solid #d1e8ff;
                    -webkit-box-shadow: 0 0 4px #198cff;
                    -moz-box-shadow: 0 0 4px #198cff;
                    box-shadow: 0 0 4px #198cff;
                    background-color: #fff;
                    .screenHead {
                        .headTxt {
                            margin-left: 20px;
                            font-size: $fontSizeFive;
                            color: $TxteAllcolor;
                            font-weight: bold;
                        }
                        .headIcon {
                            display: inline-block;
                            width: 42px;
                            height: 42px;
                            @include bgImg('../../assets/img/close.png');
                            &:hover {
                                @include bgImg('../../assets/img/closeClick.png');
                            }
                        }
                    }
                    .screenMain {
                        padding: 0 20px;
                        &.el-form {
                            min-height: 241px;
                            position: relative;
                            .formHead {
                                font-size: $fontSizeTwo;
                                color: #999999;
                            }
                            .screenMainBtn {
                                position: absolute;
                                right: 0;
                                bottom: -60px;
                            }
                        }
                    }
                }
            }
        }
        .deviceBinding{
            margin-bottom: 10px;
            @include flexible;
            @include alignItems(center);
        }
        .searchBtn {
            position: relative;
            width: 270px;
            >i {
                position: absolute;
                top: 8px;
                left: 10px;
                @include wh(16px,16px);
                @include bgImg('../../assets/img/search2.png');
                cursor: pointer;
                z-index: 1;
            }
        }
      .user_input{
        position: relative;
        width: 300px;
      }
        .tabs {
            padding: 20px 20px 0;
            .buleColor {
                border: 0;
                color: #198cff !important;
                display: inline-block;
                padding-right: 10px;
            }
          .no_btn{
            .buleColor {
              color: #282828 !important;
            }
          }
        }
    }
    .deviceCss{
      .dialog-footer{
        position: absolute;
        right: 20px;
        bottom: 20px;
        .el-button + .el-button{
          margin-left: 6px;
        }
      }
        color: #282828;
    }
  .user_table{
    .select-row{
      .cell{
        color: #198cff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/roleManger.vue